export type ChartTool = 'cursor' | 'trend' | 'hline';

const toolList: { key: ChartTool; icon: string; label: string }[] = [
  { key: 'cursor', icon: 'ri-cursor-line', label: 'Con trỏ' },
  { key: 'trend', icon: 'ri-line-chart-line', label: 'Đường xu hướng' },
  { key: 'hline', icon: 'ri-subtract-line', label: 'Đường ngang' },
];

interface Props {
  tool: ChartTool;
  onToolChange: (tool: ChartTool) => void;
  drawingCount: number;
  onClear: () => void;
}

export default function ChartToolbar({ tool, onToolChange, drawingCount, onClear }: Props) {
  return (
    <div className="flex items-center flex-wrap gap-1.5">
      {toolList.map((item) => (
        <button
          key={item.key}
          type="button"
          onClick={() => onToolChange(item.key)}
          className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-[11px] font-medium whitespace-nowrap cursor-pointer transition-colors border ${
            tool === item.key
              ? 'bg-primary-500 text-background-950 border-primary-500'
              : 'bg-background-200/60 text-foreground-700 border-background-300/60 hover:bg-background-200'
          }`}
        >
          <span className="w-3.5 h-3.5 flex items-center justify-center">
            <i className={`${item.icon} text-[13px]`}></i>
          </span>
          {item.label}
        </button>
      ))}

      {drawingCount > 0 && (
        <button
          type="button"
          onClick={onClear}
          className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-[11px] font-medium whitespace-nowrap cursor-pointer transition-colors border border-background-300/60 text-foreground-600 hover:bg-background-200/60 ml-auto"
        >
          <span className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-delete-bin-6-line text-[13px]"></i>
          </span>
          Xóa ({drawingCount})
        </button>
      )}
    </div>
  );
}